import { render, staticRenderFns } from "./wysiwyg-editor.vue?vue&type=template&id=f794cfc4&"
import script from "./wysiwyg-editor.vue?vue&type=script&lang=js&"
export * from "./wysiwyg-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports